import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=15ffdaf6"
import script from "./Contato.vue?vue&type=script&lang=ts"
export * from "./Contato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports